import React, { useState, useEffect } from 'react'
import '../css/Admin/Profile.css';
import ProfileImg from '../assets/profile.png';
import ResponseMsg from '../general/ResponseMsg';
import Loading from '../general/Loading';
import PdfImg from '../assets/pdf-img.webp';
import { Link } from 'react-router-dom';


const Profile = ({ userData }) => {
    const [response, setResponse] = useState('');
    const [showProfile, setShowProfile] = useState(true);
    const [showAddress, setShowAddress] = useState(false);
    const [showManage, setShowManage] = useState(false);
    const [showGst, setShowGst] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mypan, setMyPan] = useState();
    const [myDrug, setMyDrug] = useState();
    const [myGst, setMyGst] = useState();
  const [selectedImg, setSelectedImg] = useState();
  const [fullImg, setFullImg] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        address: '',
        city: '',
        state: '',
        pincode: '',
        gender: '',
        pan: '',
        pan_image: null,
        gst: '',
        // gst_type: '',
        // gst_state: '',
        // gst_address: '',
        gst_image: null,
        drug_license: '',
        drug_image: null,
        password: '',
    });

    // fetch userdetails from backend
    useEffect(() => {
        const fetchUserDetails = async () => {
            setLoading(true);
            try {
                const response = await fetch('https://api.kcmstore.in/dist/get-users', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ userId: userData.id, mobile: userData.mobile }),
                });

                setLoading(false);

                if (!response.ok) {
                    throw new Error('Failed to fetch user data');
                }

                const data = await response.json();
                setMyPan(data.pan_image || '');
                setMyDrug(data.drug_image || '');
                setMyGst(data.gst_image || '');
                setFormData({
                    name: data.name || '',
                    mobile: data.mobile || '',
                    email: data.email || '',
                    address: data.address || '',
                    city: data.city || '',
                    state: data.state || '',
                    pincode: data.pincode || '',
                    gender: data.gender || '',
                    pan: data.pan || '',
                    gst: data.gst || '',
                    // gst_type: data.gst_type || '',
                    // gst_state: data.gst_state || '',
                    // gst_address: data.gst_address || '',
                    drug_license: data.drug_license || '',
                    password: data.password || '',
                });
            } catch (error) {
                setLoading(false);
                console.log(error.message);
            }
        };

        fetchUserDetails();
    }, [userData]);


    const renderImageOrIcon = (fileName) => {
        const fileExtension = fileName ? fileName.split('.').pop().toLowerCase() : '';
    
        if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff'].includes(fileExtension)) {
          // If file is an image, render the image
          return (
            <img
              src={`https://api.kcmstore.in/uploads/${fileName}`}
              className="doc-img w-auto my-2"
              alt="Drug License"
              onClick={() => handleSetFullImg(fileName)}
            />
          );
        } else if (fileExtension === 'pdf') {
          // If file is a PDF, render a PDF icon
          return (
            <Link to={`https://api.kcmstore.in/uploads/${fileName}`} className='bg-white mb-3 rounded-3' target='_blank'>
              <img
                src={PdfImg}
                className="doc-img w-auto py-2"
                alt="Drug License" />
            </Link>
          );
        }
        // If the file is neither image nor PDF, render nothing
        return <p className='my-0 para-text fst-italic text-muted'>Document not Available</p>;
    };    

      const handleSetFullImg = (filename) => {
        setSelectedImg(filename);
        setFullImg(true);
      }

// Handle form field changes
const handleChange = (e) => {
    const { id, value, type, files } = e.target;

    if (type === 'file') {
        setFormData({
            ...formData,
            [id]: files[0],
        });
    } else {
        setFormData({
            ...formData,
            [id]: value,
        });
    }
};

const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Create a FormData object to send form data and files
    const formDataToSend = new FormData();
    
    for (const key in formData) {
        if (formData[key] !== null && formData[key] !== undefined) {
            formDataToSend.append(key, formData[key]);
        }
    }

// Convert FormData to key-value pairs and log
const formDataArray = [];
formDataToSend.forEach((value, key) => {
    formDataArray.push([key, value]);
});
console.log("Form Data Entries:", formDataArray);

    try {
        // Send data to backend
        const response = await fetch(`https://api.kcmstore.in/dist/update-profile/${userData.id}`, {
            method: 'PUT',
            body: formDataToSend,  // Sending FormData, which automatically handles content-type
        });

        const result = await response.json();
        setLoading(false);

        if (response.ok) {
            localStorage.setItem('userData', JSON.stringify(result));
            setResponse('Profile updated successfully!');
            setTimeout(() => {
                setResponse('');
                window.location.reload();
            }, 1500);
        } else {
            setLoading(false);
            setResponse('Failed to update profile.');
            setTimeout(() => {
                setResponse('');
            }, 2000);
        }
    } catch (error) {
        setLoading(false);
        console.error('Error updating profile:', error);
    }
};

    const indianStates = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", 
        "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", 
        "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", 
        "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", 
        "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands", 
        "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu", "Lakshadweep", 
        "Delhi", "Puducherry"
    ];


    return (
        <>
            <section className='my-4'>
                <div className='container-fluid px-3'>

                    <div className='row'>

                        <div className='col-lg-4 col-md-5 col-12 my-2'>

                            <div className='profile-card py-2 h-100'>
                                <p className='px-4 mt-3 profile-subheading'>My Profile</p>
                                <hr className='my-0' />
                                <div className='profile-img-area'>
                                    <img src={ProfileImg} className='profile-img' alt='Profile' />
                                    <p className='ms-3 py-2'>{formData.name || 'NA'}<br />{formData.address} {formData.city} {formData.state} {formData.pincode}</p>
                                </div>


                                <div className='py-4 px-3'>
                                    <p className='profile-text' onClick={() => { setShowProfile(true); setShowAddress(false); setShowManage(false); setShowGst(false) }}><i class="fa-solid me-3 fa-user"></i>Profile Details</p>
                                    <p className='profile-text' onClick={() => { setShowProfile(false); setShowAddress(true); setShowManage(false); setShowGst(false) }}><i class="fa-solid me-3 fa-map-location-dot"></i>View Address</p>
                                    <p className='profile-text' onClick={() => { setShowProfile(false); setShowAddress(false); setShowManage(false); setShowGst(true) }}><i class="fa-solid me-3 fa-tags"></i>GST & License</p>
                                    <p className='profile-text' onClick={() => { setShowProfile(false); setShowAddress(false); setShowManage(true); setShowGst(false) }}><i class="fa-solid me-3 fa-address-book"></i>Manage Profile</p>
                                </div>

                            </div>
                        </div>
                        {/* left ends */}


                        <div className='col-lg-8 col-md-7 col-12 my-2'>
                        <div className='profile-card py-4 px-4 h-100'>


                            {showProfile && (
                                <>
                                        <p className='profile-subheading'>Profile Details</p>
                                        <hr className='my-0' />


                                        <div className="col-12 profile-left-area mb-4 mt-3">
                                            <label htmlFor="name" className="form-label fw-semibold">Name</label>
                                            <p className='my-0'>{formData.name || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">Mobile Number</label>
                                            <p className='my-0'>{formData.mobile || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">Email Address</label>
                                            <p className='my-0'>{formData.email || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">Gender</label>
                                            <p className='my-0'>{formData.gender || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">Permanent Account Number (PAN)</label>
                                            <p className='my-0'>{formData.pan || 'NA'}</p>
                                            {renderImageOrIcon(mypan)}
                                        </div>

                                </>
                            )}


                            {showAddress && (
                                <>
                                        <p className='profile-subheading'>Address Details</p>
                                        <hr className='my-0' />

                                        <div className="col-12 profile-left-area mb-4 mt-3">
                                            <label htmlFor="name" className="form-label fw-semibold">Address</label>
                                            <p className='my-0'>{formData.address || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">City</label>
                                            <p className='my-0'>{formData.city || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">State</label>
                                            <p className='my-0'>{formData.state || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">Pincode</label>
                                            <p className='my-0'>{formData.pincode || 'NA'}</p>
                                        </div>

                                </>
                            )}


                            {showGst && (
                                <>
                                        <p className='profile-subheading'>GST & License Details</p>
                                        <hr className='my-0' />

                                        <div className="col-12 profile-left-area mb-4 mt-3">
                                            <label htmlFor="name" className="form-label fw-semibold">GSTIN</label>
                                            <p className='my-0'>{formData.gst || 'NA'}</p>
                                            {renderImageOrIcon(myGst)}                                        </div>

                                        {/* <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">GSTIN Type</label>
                                            <p className='my-0'>{formData.gst_type || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">GSTIN State</label>
                                            <p className='my-0'>{formData.gst_state || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">GSTIN Address</label>
                                            <p className='my-0'>{formData.gst_address || 'NA'}</p>
                                        </div> */}

                                        {/* <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">GSTIN Document</label><br />
                                            {renderImageOrIcon(myGst)}                                        </div> */}


                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">Drug License Number</label>
                                            <p className='my-0'>{formData.drug_license || 'NA'}</p>
                                            {renderImageOrIcon(myDrug)}
                                        </div>

                                </>
                            )}

                            {showManage && (
                                <>
                                        <p className='profile-subheading'>Manage Account</p>
                                        <hr className='my-0' />

                                        <form className="row g-3 mt-3" onSubmit={handleSubmit}>
                                            <div className="col-md-6">
                                                <label htmlFor="name" className="profile-label text-dark">Name</label>
                                                <input
                                                    type="text"
                                                    className="profile-input"
                                                    id="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="gender" className="profile-label text-dark">Gender</label>
                                                <select
                                                    className="profile-input"
                                                    id="gender"
                                                    value={formData.gender}
                                                    onChange={handleChange}
                                                >
                                                    <option value="" disabled>Select Gender</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="mobile" className="profile-label text-dark">Mobile Number</label>
                                                <input
                                                    type="tel"
                                                    className="profile-input"
                                                    id="mobile"
                                                    maxLength='10'
                                                    value={formData.mobile}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="email" className="profile-label text-dark">Email</label>
                                                <input
                                                    type="email"
                                                    className="profile-input"
                                                    id="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label htmlFor="pan" className="profile-label text-dark">PAN Number*</label>
                                                <input
                                                    type="text"
                                                    className="profile-input"
                                                    id="pan"
                                                    value={formData.pan}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                            <label htmlFor="pan_image" className="profile-label text-dark">PAN Document (Image/ Pdf)</label>
                            <input
                                type="file"
                                className="profile-input"
                                id="pan_image"
                                onChange={handleChange}
                            />
                        </div>

                                            <div className="col-12">
                                                <label htmlFor="password" className="profile-label text-dark">Password</label>
                                                <input
                                                    type="text"
                                                    className="profile-input"
                                                    id="password"
                                                    value={formData.password}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <p className='fw-semibold fst-italic'>Permanent Address</p>

                                            <div className="col-12">
                                                <label htmlFor="address" className="profile-label text-dark">Address</label>
                                                <input
                                                    type="text"
                                                    className="profile-input"
                                                    id="address"
                                                    value={formData.address}
                                                    style={{height: '5em'}}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label htmlFor="city" className="profile-label text-dark">City</label>
                                                <input
                                                    type="text"
                                                    className="profile-input"
                                                    id="city"
                                                    value={formData.city}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-md-4">
    <label htmlFor="state" className="profile-label text-dark fw-semibold">State</label>
    <select
        id="state"
        className="profile-input"
        value={formData.state}
        onChange={handleChange}
    >
 <option value="" disabled>Select State</option>
        {indianStates.map((state, index) => (
            <option key={index} value={state}>
                {state}
            </option>
        ))}
    </select>
</div>

                                            <div className="col-md-4">
                                                <label htmlFor="pincode" className="profile-label text-dark">Pincode</label>
                                                <input
                                                    type="text"
                                                    className="profile-input"
                                                    id="pincode"
                                                    value={formData.pincode}
                                                    onChange={handleChange}
                                                />
                                            </div>

<p className='fw-semibold fst-italic'>GST & License</p>

                                            <div className="col-md-6">
                                                <label htmlFor="gst" className="profile-label text-dark">GSTIN*</label>
                                                <input
                                                    type="text"
                                                    className="profile-input"
                                                    id="gst"
                                                    value={formData.gst}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-md-6">
                            <label htmlFor="gst_image" className="profile-label text-dark">GST Document (Image/ Pdf)</label>
                            <input
                                type="file"
                                className="profile-input"
                                id="gst_image"
                                onChange={handleChange}
                            />
                        </div>
                                            {/* <div className="col-md-4">
                                        <label htmlFor="gst_type" className="profile-label text-dark">GSTIN Type*</label>
                                        <select
                                            className="profile-input"
                                            id="gst_type"
                                            value={formData.gst_type}
                                            onChange={handleChange}
                                        >
                                            <option value="Registered">Registered</option>
                                            <option value="Not Registered">Not Registered</option>
                                        </select>
                                    </div>

                                            <div className="col-md-4">
                                                <label htmlFor="gst_state" className="profile-label text-dark">GSTIN State*</label>
                                                <input
                                                    type="text"
                                                    className="profile-input"
                                                    id="gst_state"
                                                    value={formData.gst_state}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="col-12">
                                                <label htmlFor="gst_address" className="profile-label text-dark">GSTIN Address*</label>
                                                <input
                                                    type="text"
                                                    className="profile-input"
                                                    id="gst_address"
                                                    value={formData.gst_address}
                                                    onChange={handleChange}
                                                />
                                            </div> */}

                                            <div className="col-md-6">
                                                <label htmlFor="drug_license" className="profile-label text-dark">Drug License Number*</label>
                                                <input
                                                    type="text"
                                                    className="profile-input"
                                                    id="drug_license"
                                                    value={formData.drug_license}
                                                    onChange={handleChange}
                                                />
                                            </div>

                        <div className="col-md-6">
                            <label htmlFor="drug_image" className="profile-label text-dark">Drug License Document (Image/ Pdf)</label>
                            <input
                                type="file"
                                className="profile-input"
                                id="drug_image"
                                onChange={handleChange}
                            />
                        </div>

                                            <div className="col-12 text-end">
                                                <button type="submit" className="login-btn">Update Profile</button>
                                            </div>
                                        </form>
                                </>
                            )}
                                    </div>
                        </div>
                        {/* right section ends */}


                    </div>
                    {/* row ends */}

                </div>
            </section>

            {fullImg && (
        <section className='detail-dialog'>
          <div className='detail-dialog-inner col-lg-7 mx-auto px-lg-4 py-lg-4 px-2 pb-2 text-center'>
            <img
              src={`https://api.kcmstore.in/uploads/${selectedImg}`}
              className="img-fluid my-2"
              alt="Drug License"
              onClick={() => setFullImg(true)}
            /><br />

            <button className='login-btn px-3 py-1 mt-2 bg-danger' onClick={() => setFullImg(false)}>Close</button>


          </div>
        </section>
      )}

            {loading && <Loading setLoading={setLoading} />}

            {response && <ResponseMsg message={response} />}
        </>
    )
}

export default Profile
